interface LogoProps {
  className?: string;
  showText?: boolean;
}

export default function Logo({ className = '', showText = true }: LogoProps) {
  return (
    <div className={`flex items-center ${className}`}>
      <img
        src="/images-bmg-small.webp"
        alt="Bergen Miljø & Gjenvinning"
        width={176}
        height={96}
        style={{ height: '48px', width: 'auto', maxWidth: '220px', objectFit: 'contain', display: 'block' }}
      />
      {!showText && <span className="sr-only">Bergen Miljø &amp; Gjenvinning</span>}
    </div>
  );
}
